import { render, staticRenderFns } from "./Socket.vue?vue&type=template&id=d2b9de74"
import script from "./Socket.vue?vue&type=script&lang=js"
export * from "./Socket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports